import React, { useState } from 'react';
import AddressInput from '../../components/common/AddressInput';
import { carrierApi } from '../../firebase/functionsService';
import Field from './Field';
import { ui } from './carrierStyles';

const EMPTY_ADDRESS = { street: '', city: '', lat: null, lng: null };

// Fast hentested (organizations/{orgId}/pickupLocations): navn og adresse med koordinater.
export default function PickupForm({ orgId, pickup = null, onSaved, onCancel }) {
  const [name, setName] = useState(pickup?.name ?? '');
  const [address, setAddress] = useState(pickup?.address ?? EMPTY_ADDRESS);
  const [errors, setErrors] = useState({});
  const [status, setStatus] = useState('idle');
  const [message, setMessage] = useState('');

  async function submit(e) {
    e.preventDefault();
    const found = {};
    if (!name.trim()) found.name = 'Skriv inn et navn';
    if (!address.street?.trim() || typeof address.lat !== 'number' || typeof address.lng !== 'number') found.address = 'Velg adresse fra søket';
    setErrors(found);
    if (Object.keys(found).length > 0) return;
    setStatus('saving');
    setMessage('');
    try {
      await carrierApi.saveCarrierPickup({ orgId, pickupId: pickup?.id ?? null, input: { name, address } });
      setStatus('idle');
      if (onSaved) onSaved();
    } catch (err) {
      setStatus('error');
      setMessage(err.message || 'Kunne ikke lagre hentestedet');
    }
  }

  return (
    <form onSubmit={submit} noValidate>
      <Field id="p-name" label="Navn" error={errors.name}>
        <input id="p-name" style={ui.input} value={name} onChange={e => setName(e.target.value)} maxLength={80} />
      </Field>
      <div style={{ marginTop: 10 }}>
        <AddressInput label="Adresse" value={address} onChange={setAddress} />
        {errors.address && <div role="alert" style={ui.fieldError}>{errors.address}</div>}
      </div>
      {status === 'error' && <p role="alert" style={ui.error}>{message}</p>}
      <div style={{ ...ui.row, marginTop: 14 }}>
        <button type="submit" className="tippi-btn" style={ui.btn} disabled={status === 'saving'}>
          {status === 'saving' ? 'Lagrer…' : 'Lagre hentested'}
        </button>
        {onCancel && <button type="button" style={ui.btnSecondary} onClick={onCancel}>Avbryt</button>}
      </div>
    </form>
  );
}
